import React, { useContext } from 'react';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { UserOrderContext } from 'context/context';
import { safeUpperCase } from 'common/utilities/utils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ASAP, DISPOSITION_KEYS, YYYY_MM_DD } from 'common/constants/SharedConstants';
import { currentDateTimeInFormat, formatDateTime } from 'common/utilities/dayJsUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
/**
 * Method to open open date time module
 */
const scheduleOrderButtonClickHandler = (event, selectedStoreInfo, userOrderStateDispatch) => {
  const { SCHEDULE_ORDER_DATA } = START_ORDER_CONSTANTS;
  event.preventDefault();
  event.stopPropagation();
  userOrderStateDispatch({
    type: SCHEDULE_ORDER_DATA,
    value: { showScheduleOrderCatering: true, selectedStoreInfo: selectedStoreInfo, changeFlow: true },
  });
};

const typeInfo = info_type => {
  switch (safeUpperCase(info_type)) {
    case DISPOSITION_KEYS.DELIVERY:
      return TRANSLATE_MAPPING_KEY.DELIVERY_INFO;
    case DISPOSITION_KEYS.PICKUP:
    case DISPOSITION_KEYS.CATERING:
      return TRANSLATE_MAPPING_KEY.TAKEAWAY_INFO;
    case DISPOSITION_KEYS.DINE_IN:
      return TRANSLATE_MAPPING_KEY.DINEIN_INFO;
    // no default
  }
};

const getSchedule = ({ date, time }) => {
  const isDateTomorrow = () => formatDateTime(date, YYYY_MM_DD) === currentDateTimeInFormat(YYYY_MM_DD);
  let resultElement = '';
  if (date && time) {
    let dayIs = isDateTomorrow()
      ? translateWithI18Next(TRANSLATE_MAPPING_KEY.TODAY)
      : translateWithI18Next(TRANSLATE_MAPPING_KEY.TOMORROW);
    let timeIs = time;
    resultElement = (
      <>
        <label>{dayIs}</label>
        <span>{timeIs}</span>
      </>
    );
  }

  if (time === ASAP) {
    resultElement = <label>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP)}</label>;
  }
  return resultElement;
};

const updateAddressDetails = (event, checkoutDetails, updateCheckoutDetails) => {
  const inputValue = event?.target?.value;
  updateCheckoutDetails({ address2: inputValue ? inputValue : '' });
};

const getCheckoutDispositionInfoItem = (props, userOrderStateDispatch) => {
  return (
    <LazyLoaderWrapper
      {...props}
      testId='CheckoutDispositionInfoItem'
      importPath='CHECKOUT_DISPOSITION_INFO_VIEW'
      getSchedule={getSchedule}
      typeInfo={typeInfo}
      updateAddressDetails={updateAddressDetails}
      scheduleOrderButtonClickHandler={(event, selectedStoreInfo) =>
        scheduleOrderButtonClickHandler(event, selectedStoreInfo, userOrderStateDispatch)
      }
    ></LazyLoaderWrapper>
  );
};

const CheckoutDispositionInfo = props => {
  const { userOrderStateDispatch } = useContext(UserOrderContext);

  return getCheckoutDispositionInfoItem(props, userOrderStateDispatch);
};

export default CheckoutDispositionInfo;
